import { render, staticRenderFns } from "./MaterialPractice2.vue?vue&type=template&id=c0957a20&"
import script from "./MaterialPractice2.vue?vue&type=script&lang=ts&"
export * from "./MaterialPractice2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports